"use client";

import clsx from "clsx";
import { FieldContainer } from "./FieldContainer";
import { FieldLabel } from "./FieldLabel";
import { fieldErrorClassname, fieldInputVariants } from "./field-variants";
import type { BaseFieldProps } from "./Input";
import { useFieldContext } from "../hooks/form-context";

/**
 * Textarea - Multi-line text input field
 */
export interface TextareaProps extends BaseFieldProps {
  rows?: number;
  showTestVariant?: boolean;
}

export const Textarea = ({ label, placeholder, required, name, rows = 4, showTestVariant }: TextareaProps) => {
  const field = useFieldContext();

  return (
    <FieldContainer>
      <FieldLabel label={label} htmlFor={name} required={required} showTestVariant={showTestVariant} />
      <textarea
        className={clsx(fieldInputVariants({ type: "textarea" }), "tw-resize-y")}
        id={name}
        name={name}
        placeholder={placeholder}
        required={required}
        rows={rows}
        value={field.state.value as string}
        onChange={e => field.handleChange(e.target.value)}
        onBlur={field.handleBlur}
        autoComplete='off'
      />
      {!field.state.meta.isValid && field.state.meta.isBlurred && field.state.meta.errors.length > 0 && (
        <div className={fieldErrorClassname} role='alert'>
          {field.state.meta.errors[0]}
        </div>
      )}
    </FieldContainer>
  );
};

/**
 * FieldTextarea - Alias for Textarea
 */
export const FieldTextarea = Textarea;
